import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Tooltip } from '@material-ui/core';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import { useStyles } from './VisitaFiliadoRegisterDetalhadoPasso2Styles';
import ModalidadeTrapAmericano from './ModalidadeTrapAmericano';
import MenuItem from '@material-ui/core/MenuItem';
import { Values } from '../../../../values/Values';
import Select from '@material-ui/core/Select';
import ModalidadeGeral from './ModalidadeGeral';
import { putVisitaFiliado } from '../../../../services/VisitaFiliadoService';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import DeleteIcon from '@material-ui/core/SvgIcon/SvgIcon';
import IconButton from '@material-ui/core/IconButton';
import DialogFiliadoObservacoes from '../../../../components/DialogFiliadoObservacoes/DialogFiliadoObservacoes';


function VisitaFiliadoRegisterDetalhadoPasso2(props) {
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const {
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    visitaFiliado,
    setVisitaFiliado,
    modalidades,
    armas,
    insumos,
    pacotes
  } = props;
  const classes = useStyles();
  const [modalidadeSelecionada, setModalidadeSelecionada] = useState(null);
  const [abrirDialogFiliadoObservacoes, setAbrirDialogFiliadoObservacoes] = useState(false);


  async function acrescentarModalidade() {
    try{
      if(modalidadeSelecionada){
        let visitaFiliadoModPost = {
          idVisitaFiliado: visitaFiliado.idVisitaFiliado,
          idModalidade: modalidadeSelecionada.idModalidade
        };
        setLoading(true);
        await putVisitaFiliado(visitaFiliado);
        let result = await api.post('/visita-filiado-modalidades', visitaFiliadoModPost);
        setLoading(false);
        if (result.data) {
          if (result.data.isSuccess) {
            setLoading(true);
            const dados = await api.get(`visita-filiados/${visitaFiliado.idVisitaFiliado}`);
            setLoading(false);
            if (dados.data.isSuccess) {
              if (dados.data.result && dados.data.result.length > 0) {
                if(modalidadeSelecionada.idModalidade === Values.Modalidades.trapAmericano){
                  const visitaFiliadoTrap = {
                    idVisitaFiliadoMod: dados.data.result[0].visitaFiliadoMods[dados.data.result[0].visitaFiliadoMods.length - 1].idVisitaFiliadoMod,
                    numeroRodada: 1,
                    quantidadeAcertos: 0,
                    acertoDisparo01: false, acertoDisparo02: false, acertoDisparo03: false, acertoDisparo04: false, acertoDisparo05: false,
                    acertoDisparo06: false, acertoDisparo07: false, acertoDisparo08: false, acertoDisparo09: false, acertoDisparo10: false,
                    acertoDisparo11: false, acertoDisparo12: false, acertoDisparo13: false, acertoDisparo14: false, acertoDisparo15: false,
                    acertoDisparo16: false, acertoDisparo17: false, acertoDisparo18: false, acertoDisparo19: false, acertoDisparo20: false,
                    acertoDisparo21: false, acertoDisparo22: false, acertoDisparo23: false, acertoDisparo24: false, acertoDisparo25: false
                  };
                  dados.data.result[0].visitaFiliadoMods[dados.data.result[0].visitaFiliadoMods.length - 1].visitaFiliadoTrap.push(visitaFiliadoTrap);
                }
                setVisitaFiliado(dados.data.result[0]);
                setLoading(false);
                setTypeSnack('success');
                setMessageSnack('Modalidade inserida com sucesso');
                setShowMessageSnack(true);
              } else {
                setLoading(false);
                setTypeSnack('error');
                setMessageSnack(Values.MessageValues.erro_catch);
                setShowMessageSnack(true);
              }
            } else {
              setLoading(false);
              setTypeSnack('error');
              setMessageSnack(Values.MessageValues.erro_catch);
              setShowMessageSnack(true);
            }

          } else {
            setTypeSnack('error');
            setMessageSnack(result.data.message);
            setShowMessageSnack(true);
            setLoading(false);
          }
        } else {
          setTypeSnack('error');
          setMessageSnack(Values.MessageValues.erro_catch);
          setShowMessageSnack(true);
          setLoading(false);
        }
      }
      else {
        setTypeSnack('error');
        setMessageSnack('Informe a modalidade que deseja acrescentar a visita.');
        setShowMessageSnack(true);
        setLoading(false);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch + ' ERROR: ' + e.toString());
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

  return (
      <Grid
        container
      >
        <Grid
          item
          md={10}
          xs={10}
          className={classes.margins}
        >
          <DialogFiliadoObservacoes
            filiado={visitaFiliado.filiado}
            open={abrirDialogFiliadoObservacoes}
            setOpen={setAbrirDialogFiliadoObservacoes}
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            setLoading={setLoading}
          />
        </Grid>
        <Grid
          item
          md={10}
          xs={10}
          className={classes.margins}
        >
          <TextField
            fullWidth
            variant={'outlined'}
            label={'Filiado atribuido a essa visita.'}
            value={`${visitaFiliado.filiado.cpf} - ${visitaFiliado.filiado.nome} - ${visitaFiliado.filiado.codigo ? visitaFiliado.filiado.codigo : 'Sem código'}`}
            disabled
            margin={'dense'}
          />
        </Grid>
        <Grid
          item
          md={1}
          xs={1}
        >
          <Tooltip
            title={'Clique para visualizar as observações do filiado'}
           children={
             <IconButton
               edge="end"
               onClick={e => setAbrirDialogFiliadoObservacoes(true)}
             >
               <FindInPageIcon fontSize={'default'}/>
             </IconButton>
           }
          >
          </Tooltip>
        </Grid>
        <Grid
          md={12}
          xs={12}
          className={classes.margins}
        >
          <Divider />
        </Grid>
        <Grid
          md={9}
          xs={12}
          className={classes.margins}
        >
          <Select
            fullWidth
            helperText="Escolha a modalidade que deseja acrescentar a essa visita."
            label="Modalidade"
            margin="dense"
            name="modalidade"
            value={modalidadeSelecionada}
            onChange={e => setModalidadeSelecionada(e.target.value)}
            variant="outlined"
          >
            {modalidades.result.map((modalidade, index) => (
              <MenuItem key={index} value={modalidade}>{modalidade.descricao}</MenuItem>
            ))}

          </Select>

        </Grid>
        <Grid
          md={2}
          xs={12}
          className={classes.margins}
        >
          <Button
            className={classes.signInButton}
            color="primary"
            fullWidth
            size="large"
            onClick={e => acrescentarModalidade()}
            margin='dense'
            variant="outlined"
          >
            Confirmar
          </Button>

        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          {visitaFiliado.visitaFiliadoMods && visitaFiliado.visitaFiliadoMods.map((modalidade, index) => {
            if(modalidade.idModalidade === Values.Modalidades.trapAmericano ){
              if(modalidade.visitaFiliadoTrap.length <= 0){
                const visitaFiliadoTrap = {
                  idVisitaFiliadoMod: modalidade.idVisitaFiliadoMod,
                  numeroRodada: 1,
                  quantidadeAcertos: 0,
                  acertoDisparo01: false, acertoDisparo02: false, acertoDisparo03: false, acertoDisparo04: false, acertoDisparo05: false,
                  acertoDisparo06: false, acertoDisparo07: false, acertoDisparo08: false, acertoDisparo09: false, acertoDisparo10: false,
                  acertoDisparo11: false, acertoDisparo12: false, acertoDisparo13: false, acertoDisparo14: false, acertoDisparo15: false,
                  acertoDisparo16: false, acertoDisparo17: false, acertoDisparo18: false, acertoDisparo19: false, acertoDisparo20: false,
                  acertoDisparo21: false, acertoDisparo22: false, acertoDisparo23: false, acertoDisparo24: false, acertoDisparo25: false
                };
                visitaFiliado.visitaFiliadoMods[index].visitaFiliadoTrap.push(visitaFiliadoTrap);
                setVisitaFiliado(visitaFiliado)
              }
              return <ModalidadeTrapAmericano
                visitaFiliado={visitaFiliado}
                setVisitaFiliado={setVisitaFiliado}
                indexModalidade={index}
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
                setLoading={setLoading}
                armas={armas}
                insumos={insumos}
                pacotes={pacotes}
              />
            }
            else{
              return <ModalidadeGeral
                visitaFiliado={visitaFiliado}
                setVisitaFiliado={setVisitaFiliado}
                indexModalidade={index}
                indexVisitaFiliadoTrap={0}
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
                setLoading={setLoading}
                armas={armas}
                insumos={insumos}
                pacotes={pacotes}

              />
            }
          })}
        </Grid>
      </Grid>

  );
};

VisitaFiliadoRegisterDetalhadoPasso2.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default VisitaFiliadoRegisterDetalhadoPasso2;


